import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import BigFloatButton from '../../components/BigFloatButton/BigFloatButton';
import { EmptyListFallback } from '../../components/EmptyListFallback/EmptyListFallback';
import { ImOkItem } from '../../components/ImOkItem/ImOkItem';
import Loader from '../../components/Loader/Loader';
import { Page } from '../../components/Page/Page';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { fetchGroups } from '../GroupsList/groupsSlice/actionCreators';
import { selectUserPermissions } from '../Login/LoginSlice';
import { SIamokStatus } from './im-ok.styles';
import { selectImOkIsLoading, selectImOkList, setImOkDocument } from './imOkSlice';
import { fetchImOkList } from './imOkSlice/actionCreators';

const SPage = styled(Page)`
  padding: 1.25rem 0rem;
  /* to make only the list overflow */
  position: relative;
  height: 100%;
`;

const SList = styled.ul`
  width: 90%;
  margin: auto;

  list-style-type: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  .gap {
    height: 0.5rem;
  }

  overflow-y: auto;
  height: calc(100%);

  padding-bottom: 3rem;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const ImOkList = () => {
  const dispatch = useAppDispatch();
  const imOkList = useAppSelector(selectImOkList);
  const isLoading = useAppSelector(selectImOkIsLoading);
  const { t } = useTranslation();

  const userPermissions = useAppSelector(selectUserPermissions);
  const canStartIamOk = userPermissions?.imOk.mayActivate;

  useEffect(() => {
    dispatch(setImOkDocument(null));
    dispatch(fetchImOkList());
    dispatch(fetchGroups());
  }, [dispatch]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <SPage>
      <SList id="imOkList">
        {imOkList.length ? (
          imOkList.map(imOk => <ImOkItem key={`${imOk.id}--`} imOk={imOk} />)
        ) : (
          <EmptyListFallback
            listLength={imOkList.length}
            isLoading={false}
            emptyListTx={'imOk_empty'}
          />
        )}
      </SList>
      {canStartIamOk && <BigFloatButton link={'/startIamOk'} tx={'imOk_create'} />}
      {!canStartIamOk && <SIamokStatus>{t('IamOK_start_replacer')}</SIamokStatus>}
    </SPage>
  );
};
